
interface IconButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  badgeCount?: number;
  className?: string;
  ariaLabel?: string;
}

const IconButton: React.FC<IconButtonProps> = ({
  children,
  onClick,
  badgeCount = 0,
  className = "",
  ariaLabel,
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      className={`relative text-white hover:opacity-80 transition ${className}`}
    >
      {children}

      {badgeCount > 0 && (
        <span className="w-5 h-5 text-xs absolute bg-primary rounded-full -top-2 -right-2 flex items-center justify-center">
          {badgeCount}
        </span>
      )}
    </button>
  );
};

export default IconButton;